export enum LoginTypeEnum {
    Employee = 1,
    Admin = 2,
    DrivingLog = 3
}
